import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { OFFICER_BASE_DETAILS_KEY } from './data/officer-details-store.state';
import { OfficerDetailsReducer } from './data/officer-details-store.reducer';
import { OfficerDetailsEffects } from './data/officer-details.store.effects';
import { TimezonePipe } from './pipes/timezone.pipe';
import { TimezoneSimplePipe } from '@shared/utils/time-zones';

@NgModule({
  imports: [CommonModule, StoreModule.forFeature(OFFICER_BASE_DETAILS_KEY, OfficerDetailsReducer), EffectsModule.forFeature([OfficerDetailsEffects])],
  declarations: [TimezonePipe],
  exports: [TimezonePipe],
  providers: [TimezoneSimplePipe],
})
export class IntrensicSharedOfficerDetailsModule {}
